// extracted by mini-css-extract-plugin
export var background = "backSpace-module--background--eio66";
export var arrow = "backSpace-module--arrow--1DHG6";